import React from 'react';
import INFO_EVENTS from '../../common/constants/infoEvents';
import CustomButtonIcon from './CustomButtonIcon';
import { utils } from '../../common/utils/utils';
import { optionsMap, GALLERY_CONSTS } from 'pro-gallery-lib';
class CustomButton extends React.Component {
  render() {
    const {
      options,
      actions
    } = this.props;
    const buttonText = options.customButtonText || 'Click here';

    // Flip alignment sides when RTL
    let justifyContent = this.props.isNewInfoElements ? this.props.horizontalAlignment : options.controllers_layoutParams_info_horizontalAlignment;
    if (options[optionsMap.behaviourParams.gallery.layoutDirection] === GALLERY_CONSTS[optionsMap.behaviourParams.gallery.layoutDirection].RIGHT_TO_LEFT) {
      justifyContent = utils.flipGalleryHorizontalAlign(options.controllers_layoutParams_info_horizontalAlignment);
    }
    const style = {
      justifyContent,
      zIndex: 17
    };
    if (this.props.isNewInfoElements) {
      style.paddingTop = this.props.paddingTop;
      style.paddingBottom = this.props.paddingBottom;
      style.paddingLeft = this.props.paddingLeft;
      style.paddingRight = this.props.paddingRight;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "info-member info-element-custom-button-wrapper",
      "data-hook": "custom-button-wrapper",
      style: style
    }, this.props.small && options.isStoreGallery ? /*#__PURE__*/React.createElement(CustomButtonIcon, null) : /*#__PURE__*/React.createElement("button", {
      "data-hook": "custom-button-button",
      className: "info-element-custom-button-button",
      onClick: () => actions.eventsListener(INFO_EVENTS.CUSTOM_BUTTON_CLICKED, this.props),
      style: {
        cursor: 'inherit'
      },
      tabIndex: -1
    }, buttonText, /*#__PURE__*/React.createElement("div", {
      className: "overlay"
    })));
  }
}
export default CustomButton;
//# sourceMappingURL=CustomButton.js.map